export enum Feature {
  SpotifyIntegration = 'SpotifyIntegration',
  DefaultBuyProvider = 'DefaultBuyProvider',
  MaxRequests50 = 'MaxRequests50',
  MaxEvents10 = 'MaxEvents10',
}
